import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ManageTravelArrangementComponent } from '../../manage-travel-arrangement/manage-travel-arrangement.component';
import { DateConstants } from '../../../utilities/WeekSchedule/DateConstants';
import * as moment from 'moment';
import { CONSTANTS } from '../../../utilities/Constants';

@Component({
  selector: 'app-manage-travel-event-dialog',
  templateUrl: './manage-travel-event-dialog.component.html',
  styleUrls: ['./manage-travel-event-dialog.component.css']
})
export class ManageTravelEventDialogComponent implements OnInit {
  info;
  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageTravelEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.info = data;
  }

  ngOnInit() {

  }

  cancel(pickupid, pickuptime) {
    this.dialogRef.close({
      id: pickupid,
      time: pickuptime
    });
  }

  formatheading(pickuptime) {
    return moment(pickuptime).utc().format('ddd MMM DD, hh:mm A');
  }

  isWork(type) {
    if (type == CONSTANTS.PICKUP_TYPE_WORK) {
      return true;
    }
    return false;
  }
  isHome(type) {
    if (type == CONSTANTS.PICKUP_TYPE_HOME) {
      return true;
    }
    return false;
  }

  getPickupType(pickupType) {
    if (pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
      return 'Work Pickup';
    } else {
      return 'Home Pickup';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/user-dashboard/dialogs/manage-travel-event-dialog/manage-travel-event-dialog.component.ts